// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__PgZnl","title":"style_title__j+n4l","reason":"style_reason__VMo1s","reason_list":"style_reason_list__kA4Er"};